{
  "registers": {
    "intro": "お店のレジ（端末）一覧。タブレット・プリンター・ドロアーを管理します。新しいタブレットは1回だけ使えるコードでつなぎます。",
    "new": "レジを追加",
    "tabs": "レジかPIN",
    "tab_registers": "レジ",
    "tab_pins": "スタッフのPIN",
    "load_failed": "レジを読み込めませんでした。",
    "empty": "レジがまだありません",
    "empty_body": "最初のレジを追加して、コードでタブレットをつないでください。",
    "pair": "ペアリングコードを発行",
    "edit": "変更",
    "shifts": "このレジのシフト",
    "status_active": "使用中",
    "status_disabled": "停止中",
    "edc_note": "カード端末と手数料は「支払い」で設定します。",
    "edc_link": "支払いを開く"
  },
  "card": {
    "location": "店舗",
    "shift": "レジ",
    "open_by": "{{name}}が開局",
    "closed": "締め済み",
    "printer": "レシートプリンター",
    "no_printer": "プリンターなし",
    "drawer": "ドロアー",
    "drawer_yes": "あり",
    "drawer_no": "なし"
  },
  "tablets": {
    "none": "つながっているタブレットはありません。",
    "count_one": "タブレット{{count}}台",
    "count_other": "タブレット{{count}}台",
    "online": "オンライン",
    "last_seen": "最後の接続",
    "never": "まだ使っていません",
    "revoke": "接続解除",
    "revoke_title": "このタブレットの接続を解除しますか？",
    "revoke_consequence": "すぐに使えなくなり、ログイン中のスタッフもログアウトされます。新しいコードでつなぎ直せます。",
    "revoked": "接続を解除しました。"
  },
  "form": {
    "new_title": "レジを追加",
    "edit_title": "{{name}}を変更",
    "name": "名前",
    "name_hint": "スタッフの呼び方。例：「カウンター1」",
    "code": "短いコード",
    "code_hint": "レシートに印字されます。例：REG-1",
    "location": "店舗",
    "drawer": "キャッシュドロアー",
    "drawer_hint": "現金会計の後に開きます。",
    "printer": "レシートプリンター",
    "ip": "プリンターのアドレス（IP）",
    "ip_hint": "プリンターのテスト印字に出ます。例：192.168.1.50",
    "bt": "Bluetoothの名前",
    "bt_hint": "タブレットのBluetooth一覧に出る名前。",
    "paper": "用紙幅",
    "active": "使用中",
    "required": "入力してください。",
    "create": "保存してタブレットをつなぐ",
    "save": "保存",
    "created": "レジを追加しました。",
    "saved": "保存しました。"
  },
  "printer": {
    "network": "LAN / Wi-Fi",
    "network_help": "お店のネットワークにあるプリンター。テスト印字に出るアドレスを入れます。",
    "bluetooth": "Bluetooth",
    "bluetooth_help": "先にタブレットとペアリングし、その名前を入れます。",
    "webusb": "USBケーブル",
    "webusb_help": "タブレットにケーブルでつなぎます。最初に一度だけ許可を求められます。",
    "sunmi": "内蔵（Sunmi）",
    "sunmi_help": "Sunmi端末に内蔵のプリンター。入力は不要です。",
    "none": "プリンターなし",
    "none_help": "レシートはメールだけで送ります。"
  },
  "pairing": {
    "title": "{{name}}にタブレットをつなぐ",
    "intro": "表示中の時間内に、このコードをタブレットに入力します。コードは1回だけ使えます。",
    "making": "コードを作成中…",
    "code_label": "コード {{code}}",
    "left": "残り {{time}}",
    "expired": "このコードは期限切れです。",
    "again": "新しいコード",
    "qr": "タブレット用のQRコード",
    "step1": "タブレットでレジアプリを開きます。",
    "step2": "タブレットに「端末の登録」画面が出ます。下のコードだけで {{name}}（{{code}}）につながります（レジを選ぶ必要はありません）。",
    "step3": "このコードを入力（またはQRを読み取り）。",
    "once": "コードはここにだけ表示され、閉じると消えます。",
    "close": "閉じる"
  },
  "pin": {
    "intro": "スタッフがレジで使うPINです。リセットは確認のうえ記録されます。",
    "has": "PINあり",
    "none": "PINなし",
    "reset": "PINをリセット",
    "load_failed": "スタッフ一覧を読み込めませんでした。",
    "title": "{{name}}さんのPINをリセットしますか？",
    "consequence": "今のPINはすぐに使えなくなります。",
    "how": "新しいPIN",
    "temporary": "仮のPIN",
    "temporary_hint": "ここに1回だけ表示します。本人に伝え、レジで自分のPINに変えてもらいます。",
    "clear": "PINなし（レジで本人が設定）",
    "clear_hint": "一度パスワードでログインしてPINを設定します。",
    "cancel": "PINはそのまま",
    "confirm": "PINをリセット",
    "shown_once": "このPINを今スタッフに伝えてください。二度と表示されません。",
    "cleared": "PINを消しました。レジで新しいPINを設定してもらいます。",
    "done": "完了"
  },
  "receipt": {
    "header_title": "レシートの上部",
    "shop_name": "店名",
    "tnumber": "登録番号",
    "kobutsu": "古物商許可番号",
    "address": "住所・電話",
    "not_set": "未設定",
    "placeholder": "仮の番号（まだ本番ではありません）",
    "change_in_tax": "税の設定で変更",
    "change_in_store": "ストア設定で変更",
    "texts_note": "お礼の文と返品ルールはシステムの設定から出ます。ここでの変更は後の対応です。",
    "preview_label": "レシートの見本",
    "preview_caption": "このページの設定での80 mmレシート（見本のカード）。",
    "no_name": "（店名）",
    "consigned_note": "委託品はお店の商品と分けてここに印字されます。",
    "qr_line": "電子レシートはこちらから"
  },
  "rules": {
    "intro": "レジの動き方：オフライン、値引き、買取、取り置き、ラベル。それぞれの説明付きです。",
    "tabs": "ルールかレシート",
    "tab_rules": "ルール",
    "tab_receipt": "レシート",
    "load_failed": "レジのルールを読み込めませんでした。",
    "groups": {
      "offline": "ネットが切れたとき",
      "money": "値引きとドロアー",
      "buylist": "買取",
      "holds": "取り置き",
      "labels": "ラベルと古物台帳",
      "tax_free": "免税",
      "receipt": "レシート"
    },
    "tax_free_on": "免税の許可が設定されています。",
    "tax_free_needs_licence": "先に輸出物品販売場の許可を設定してください。",
    "tax_free_link": "税の設定を開く",
    "default": "お店の標準に戻す（{{value}}）",
    "save": "ルールを保存",
    "saved": "保存しました。1分以内にレジに反映されます。",
    "changed_one": "{{count}}件の変更",
    "changed_other": "{{count}}件の変更",
    "nothing": "変更なし",
    "read_only": "ルールを変更できるのはオーナーだけです。",
    "problems": {
      "number": "整数で入れてください。",
      "min": "{{min}}以上にしてください。",
      "max": "{{max}}以下にしてください。",
      "choice": "選んでください。",
      "text": "入力してください。"
    }
  },
  "units": {
    "minutes": "分",
    "percent": "%",
    "days": "日",
    "count": "件",
    "yen": "円"
  },
  "choices": {
    "defaultDocumentType": {
      "kani_invoice": "適格簡易請求書",
      "tekikaku_invoice": "適格請求書"
    },
    "defaultReceiptMode": {
      "print": "紙",
      "email": "メール",
      "print_and_email": "紙とメール",
      "ask": "毎回聞く"
    },
    "labelSizeDefault": {
      "40x30": "40 × 30 mm",
      "58x40": "58 × 40 mm"
    }
  },
  "shifts": {
    "title": "シフト",
    "intro": "レジのシフトごとの売上・過不足・Zレポート。開局と締めはレジで行います。",
    "cash_intro": "ドロアーごとの現金：開始時のつり銭、あるべき金額、数えた金額、過不足。",
    "period": "日付（日本時間）",
    "register": "レジ",
    "only_difference": "過不足ありだけ",
    "opened": "開局",
    "closed": "締め",
    "still_open": "営業中",
    "float": "つり銭",
    "expected": "あるべき金額",
    "counted": "実際の金額",
    "variance": "過不足",
    "sales_count": "会計数",
    "net": "返品後の売上",
    "fee": "カード手数料",
    "z_report": "Zレポート",
    "z_ready": "あり",
    "z_none": "まだ締めていません",
    "z_pending": "作成中",
    "z_issued": "あり",
    "z_unsupported": "まだ使えません",
    "drawer": "ドロアー",
    "approved_by": "店長が過不足を承認：{{name}}",
    "by_tender": "支払い方法ごと",
    "tender": "支払い",
    "count": "件数",
    "sales": "売上",
    "refunds": "返金",
    "tax": "消費税",
    "discount": "値引き",
    "pickups": "受け取りのWeb注文",
    "review": "要確認",
    "card_fees": "カード端末の手数料",
    "status_open": "営業中",
    "status_closed": "締め済み",
    "cash_moves_note": "入金・出金とその理由はZレポートPDFに載っています。管理画面での一覧は後の対応です。"
  },
  "tenders": {
    "cash": "現金",
    "edc_external": "カード端末",
    "store_credit": "ストアクレジット",
    "stripe_terminal": "カード（Stripe）",
    "stripe_payment_link": "QR決済（Stripe）",
    "pay_in_store": "店頭払い",
    "bank_transfer_manual": "銀行振込"
  },
  "buylist": {
    "intro": "レジで買い取ったカード（古物台帳から）。買取はレジで行います。",
    "paid": "買取金額",
    "seller": "売り主",
    "purchase": "買取番号",
    "no_access": "古物台帳を見られるスタッフだけが買取を見られます。",
    "note": "支払い方法と買取明細はレジにあります。すべての記録は古物台帳にあります。",
    "open_ledger": "古物台帳を開く"
  }
}
